import { defineMessages } from 'react-intl'

const scope = `procurify.platform.site-operations.pages.AdminToolsPage`

export default defineMessages({
  adminToolsTitle: {
    id: `${scope}.adminToolsTitle`,
    defaultMessage: 'Admin tools',
  },
})
